import { aroApiSlice } from './apiSlice';
import { getBaseURL } from '../../../utilities/config';
import { buildMapQueryString } from '../../../utilities/mapHelpers';

// To Do: use baseURL and remove full url from query
export const mapApiSlice = aroApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMapInitData: builder.query({
            query: () => `${getBaseURL()}/mapapi?init=true`,
        }),
        getMapData: builder.query({
            query: (query) => ({
                url: `${getBaseURL()}/mapapi?${buildMapQueryString(query)}`,
                method: 'GET',
                meta: { skipRetry: true },
            }),
        }),
    }),
});

export const { useGetMapInitDataQuery,  useLazyGetMapInitDataQuery, useLazyGetMapDataQuery } = mapApiSlice;
